import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { loadingStore } from '@pascal/pascal-core';
import { totalBetStore } from '../store/totalBetStore';
import { liveBetsDataStore } from '../store/liveBetsDataStore';
import { gameStore } from '../store/gameStore';
import { BetShopSecondView } from '../components/betShopSecondView';
import { BetShopFirstView } from '../components/betShopFirstView';

const BetShopGame = observer(() => {
  const { isBetsClosed } = gameStore;

  useEffect(() => {
    return () => {
      totalBetStore.setTotalBet(0);
      liveBetsDataStore.resetLiveBetsData([]);
      loadingStore.updateLoading({ isGameInitialLoaded: false });
    };
  }, []);
  return (
    <div className='betshop-baccarat'>
      {!isBetsClosed ? <BetShopFirstView /> : <BetShopSecondView />}
    </div>
  );
});
export default BetShopGame;
